import {Model} from 'MWC';

const yearDays = 365,
    hundredPercent = 100,
    realRates = 'real_rates';

const RATE_THRESHOLDS = [1000000, 3000000, 5000000];

export default class extends Model {
    static fields;

    constructor(data) {
        super();
        this.creditSum = 10000000;
        this.realRate = data[realRates][0];
        this.realRates = data[realRates];
        this._initFields(data);
    }

    _initFields(data) {
        this.fields = {
            ...data
        };
    }

    changeField(name, value) {
        this[name] = value;

        this.calculateIndicators();
    }

    getRealRate() {
        return this.realRate;
    }

    setRealRate(value) {
        this.realRate = value;
    }

    setIncome(value) {
        this.income = value;
    }

    getIncome() {
        return this.income;
    }

    getCreditSum() {
        return +this.creditSum;
    }

    getMinSumEdge() {
        return +this.fields.min;
    }

    getMaxSumEdge() {
        return +this.fields.max;
    }

    getSumStep() {
        return +this.fields.step;
    }

    calculateIndicators() {
        const creditSum = this.getCreditSum();

        let realRate;

        if (creditSum < this.getMinSumEdge()) {
            realRate = 0;
        } else if (creditSum <= RATE_THRESHOLDS[0]) {
            realRate = this.fields[realRates][0];
        } else if (creditSum <= RATE_THRESHOLDS[1]) {
            realRate = this.fields[realRates][1];
        } else if (creditSum <= RATE_THRESHOLDS[2]) {
            realRate = this.fields[realRates][2];
        } else {
            realRate = this.fields[realRates][3];
        }

        const income = this._round((creditSum * realRate) / hundredPercent / yearDays);

        this.setRealRate(realRate);
        this.setIncome(income);
    }

    _round(value) {
        return Math.round(value * hundredPercent) / hundredPercent;
    }
}
